import { useCallback, useEffect, useState } from 'react';

import { validateDecimalInput, validateDigitsInput } from '../../../utils/formatUtils';
import useToast from '../../../hooks/useToast';
import { getClasificationApprover, getOperationalDetails } from '../../../services/workReport';

const useProgramPoint = (props) => {
  const {
    setFieldValue,
    values,
    notificaPorCSA,
    tipoAsignacion,
    idParteDiario,
    evento,
    formName = '',
    indexPP
  } = props;
  const { setNewToast } = useToast();
  const [costOptions, setCostOptions] = useState([]);

  const fetchCode = async (val, index) => {
    const body = {
      tipoAsignacion,
      claseCosto: val.costoClase,
      fase: val.fase
      // codigo: 'T',
      // subcodigo: '140'
    };

    const response = await getOperationalDetails(idParteDiario, body);

    const adapterCode = response?.codigo?.map((code, indexCode) => ({
      nombre: code,
      id: indexCode + 1
    }));

    setFieldValue(`${formName}programPoints[${index}].optionsCode`, adapterCode);
  };

  const fetchSubCodes = async (val, index) => {
    try {
      const body = {
        tipoAsignacion,
        claseCosto: values?.programPoints[index]?.cost?.costoClase,
        fase: values?.programPoints[index]?.cost?.fase,
        codigo: val.nombre
        // subcodigo: '140'
      };
      const response = await getOperationalDetails(idParteDiario, body);

      const dataFilterSubCode = response?.subcodigo?.map((sub, indexSub) => ({
        nombre: sub,
        id: indexSub + 1
      }));

      setFieldValue(`${formName}programPoints[${index}].optionsSubCode`, dataFilterSubCode);
    } catch (error) {
      setNewToast({ type: 'ERROR', message: error.message });
    }
  };

  const fetchCost = async (index) => {
    try {
      const body = {
        tipoAsignacion
        // claseCosto: 'EQP',
        // fase: '10b',
        // codigo: 'T',
        // subcodigo: '140'
      };

      if (index === 0 && values?.habilitaVentana) {
        const response = await getOperationalDetails(idParteDiario, body);
        const adapterData = response?.costoClase?.map((cost) => ({
          ...cost,
          nombreCorto: cost.costoClase,
          nombre: cost.combinacion,
          id: `${cost.costoClase} | ${cost.fase}`
        }));

        setCostOptions(adapterData || []);

        values?.programPoints?.forEach((item, idxPP) => {
          setFieldValue(`${formName}programPoints[${idxPP}].costOptions`, adapterData || []);
        });
      }
    } catch (error) {
      setNewToast({ type: 'ERROR', message: error.message });
    }
  };

  const fetchDetails = async (val, index) => {
    try {
      const body = {
        tipoAsignacion,
        claseCosto: values?.programPoints[index]?.cost?.costoClase,
        fase: values?.programPoints[index]?.cost?.fase,
        codigo: values?.programPoints[index]?.code?.label,
        subcodigo: val?.label
      };
      const response = await getOperationalDetails(idParteDiario, body);

      setFieldValue(`${formName}programPoints[${index}].detail`, response.descripcion || []);
    } catch (error) {
      setNewToast({ type: 'ERROR', message: error.message });
    }
  };

  const recalculateSum = (value = 0) => {
    let formattedTotalValue = value.toFixed(3).replace(/0+$/, '');

    if (formattedTotalValue.endsWith('.')) {
      formattedTotalValue = formattedTotalValue.slice(0, -1);
    }

    return formattedTotalValue;
  };
  const handleAddPP = () => {
    const firstPP = values?.programPoints && values?.programPoints[0];

    setFieldValue(`${formName}programPoints`, [
      ...values.programPoints,
      { ...firstPP, quantity: '', points: '' }
    ]);
  };

  const handleSuprPP = (pLIndex) => {
    const newProgramPoints = values.programPoints.filter((_, index) => index !== pLIndex);

    let newTotalValue;

    if (newProgramPoints?.length > 0) {
      newTotalValue = newProgramPoints.reduce(
        (acc, curr) => parseFloat(acc) + parseFloat(curr.quantity || 0),
        0
      );
    } else {
      newTotalValue = 0;
    }
    const valueTotalFixed = recalculateSum(newTotalValue);

    setFieldValue(`${formName}programPoints`, newProgramPoints);
    setFieldValue(`${formName}totalValue`, valueTotalFixed);
  };

  const handleChangeQuantity = useCallback(
    async (val, index) => {
      const { value } = val.target;

      if (validateDecimalInput(value, 3)) {
        const newTotalValue = values.programPoints?.reduce((acc, curr, i) => {
          if (i === index) {
            if (value === '') return acc;

            return parseFloat(acc) + parseFloat(value);
          }
          if (curr?.quantity === '') return parseFloat(acc);

          return parseFloat(acc) + parseFloat(curr.quantity || 0);
        }, 0);

        const valueTotalFixed = recalculateSum(newTotalValue);

        setFieldValue(`${formName}programPoints[${index}].quantity`, value);
        setFieldValue(`${formName}totalValue`, valueTotalFixed);
      }
    },
    [values, setFieldValue]
  );

  const handleChangePoints = useCallback(
    async (val, index) => {
      const { value } = val.target;

      if (value === '0') return;

      if (validateDigitsInput(value, 4)) {
        setFieldValue(`${formName}programPoints[${index}].points`, value);
      }
    },
    [setFieldValue]
  );

  const handleChangeCode = async (val, index) => {
    setFieldValue(`${formName}programPoints[${index}].subCode`, '');
    setFieldValue(`${formName}programPoints[${index}].detail`, '');

    setFieldValue(`${formName}programPoints[${index}].code`, {
      ...val,
      nombre: val.label,
      id: val.value,
      label: val.label,
      value: val.value
    });
    fetchSubCodes(val, index);
  };

  const handleChangeSubCode = async (val, index) => {
    setFieldValue(`${formName}programPoints[${index}].detail`, '');
    setFieldValue(`${formName}programPoints[${index}].subCode`, {
      ...val,
      nombre: val.label,
      id: val.value,
      label: val.label,
      value: val.value
    });

    fetchDetails(val, index);
  };
  const handleChangeCost = async (val, index) => {
    setFieldValue(`${formName}programPoints[${index}].subCode`, '');
    setFieldValue(`${formName}programPoints[${index}].code`, '');
    setFieldValue(`${formName}programPoints[${index}].detail`, '');
    setFieldValue(`${formName}programPoints[${index}].clasification`, '');

    setFieldValue(`${formName}programPoints[${index}].cost`, {
      ...val,
      nombre: val.nombreCorto,
      nombreLargo: val.nombre,
      id: val.value,
      label: `${val.costoClase} - ${val.fase}`,
      value: val.value
    });
    fetchCode(val, index);
    const clasification = await getClasificationApprover(val.fase, evento);

    const classificationOptions = clasification?.map((item) => ({
      ...val,
      nombre: item.nombre,
      id: item.sigla,
      label: item.nombre,
      value: item.sigla
    }));

    if (classificationOptions?.length > 0) {
      setFieldValue(`${formName}programPoints[${index}].clasification`, {
        ...classificationOptions[0],
        nombre: classificationOptions[0]?.value || classificationOptions[0]?.nombre,
        id: classificationOptions[0]?.value || classificationOptions[0]?.nombre,
        label: classificationOptions[0]?.value || classificationOptions[0]?.nombre,
        value: classificationOptions[0]?.value || classificationOptions[0]?.nombre
      });
    }
    setFieldValue(
      `${formName}programPoints[${index}].optionsClasification`,
      classificationOptions || []
    );
  };

  const handleChangeClasification = async (val, index) => {
    setFieldValue(`${formName}programPoints[${index}].clasification`, {
      ...val,
      nombre: val.value,
      id: val.value,
      label: val.value,
      value: val.value
    });
  };

  const handleFirstDetails = async (index) => {
    if (values?.programPoints[index]?.cost && values?.programPoints[index]?.code) {
      await fetchCode(values?.programPoints[index].cost, index);
    }
  };

  useEffect(() => {
    if (idParteDiario) {
      fetchCost(indexPP);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificaPorCSA, indexPP]);

  useEffect(() => {
    handleFirstDetails(indexPP);
    const newTotalValue = values?.programPoints.reduce((acc, curr) => {
      if (curr?.quantity === '') return parseFloat(acc);

      return parseFloat(acc) + parseFloat(curr.quantity || 0);
    }, 0);

    const valueTotalFixed = recalculateSum(newTotalValue);

    setFieldValue(`${formName}totalValue`, Number(valueTotalFixed));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [indexPP]);

  return {
    handleSuprPP,
    handleChangeQuantity,
    handleAddPP,
    handleChangePoints,
    handleChangeCode,
    handleChangeSubCode,
    handleChangeCost,
    handleChangeClasification,
    fetchDetails,
    fetchCode,
    costOptions: values?.programPoints[indexPP]?.costOptions || costOptions || []
  };
};

export default useProgramPoint;
